import React from "react";
import RemoteFailurePanel from "./remote-failure-panel";

interface RemoteErrorBoundaryProps {
  children: React.ReactNode;
  remote?: string;
  exposedModule?: string;
  onRetry?: () => void;
  fallback?: (error: Error) => React.ReactNode;
}

interface RemoteErrorBoundaryState {
  error: Error | null;
}

class RemoteErrorBoundary extends React.Component<
  RemoteErrorBoundaryProps,
  RemoteErrorBoundaryState
> {
  state: RemoteErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): RemoteErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error("[module-federation] Remote component render failed", {
      remote: this.props.remote,
      exposedModule: this.props.exposedModule,
      error,
      componentStack: errorInfo.componentStack,
    });
  }

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback(this.state.error);
      return (
        <RemoteFailurePanel
          remote={this.props.remote ?? "unknown"}
          exposedModule={this.props.exposedModule ?? "unknown"}
          phase="render"
          error={this.state.error}
          onRetry={this.props.onRetry}
        />
      );
    }
    return this.props.children;
  }
}

export default RemoteErrorBoundary;
